// AI质检状态 -> el-tag type 映射
export const STATUS_TAG_TYPE = {
  1: 'warning', // 待质检
  2: 'success', // 已确认
  3: 'info', // 仅提醒
  4: 'info', // 误报
  5: 'primary', // 申诉处理中
  6: 'success', // 申诉通过
  7: 'danger', // 申诉驳回
  8: 'info', // 无需处理
};

// 操作码 -> 按钮文案
export const OPERATION_BUTTON_TEXT = {
  confirm: '确认',
  remind_only: '仅提醒',
  false_hit: '误报',
  no_action: '无需处理',
  appeal: '申诉',
  appeal_pass: '通过',
  appeal_reject: '驳回',
};

// 标签 -> el-tag type，态度/严重类标签用红色突出
export function labelTagType(label) {
  if (label.includes('态度')) return 'danger';
  if (label.includes('严重')) return 'danger';
  if (label.includes('情绪')) return 'warning';
  return '';
}

// 回复间隔仅对超时类标签有意义
export function shouldShowReplyInterval(labels) {
  return (labels || []).some(item => {
    const label = item.label || item;
    return label === '超时未回复' || label === '严重超时未回复';
  });
}

// 仅格式化时效规则生成的原因，兼容历史记录；各标签使用自身文案里的等待秒数。
export function formatTimelinessReason(text, sourceType) {
  if ((sourceType !== 1 && sourceType !== '1') || typeof text !== 'string') return text;
  const match = /^玩家消息触发(临近超时|超时未回复|严重超时未回复|漏回)，有效工作等待(\d+)秒$/.exec(text);
  if (!match) return text;
  const totalSeconds = Number(match[2]);
  if (!Number.isSafeInteger(totalSeconds)) return text;
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  const duration = (hours ? `${hours}小时` : '')
    + (minutes ? `${minutes}分` : '')
    + (seconds || totalSeconds === 0 ? `${seconds}秒` : '');
  return `玩家消息触发${match[1]}，有效工作等待${duration}`;
}

// 行/详情返回的 available_operations 只反映状态机可流转的操作，不代表当前用户是否有权限操作；
// 必须和 options?types=operation 下发的权限操作集合取交集，才能决定按钮最终是否展示
export function filterVisibleOperations(rowOperations, permittedOperations) {
  if (!permittedOperations || !permittedOperations.length) {
    return [];
  }
  const permittedSet = new Set(permittedOperations.map(item => item.value));
  return (rowOperations || []).filter(op => permittedSet.has(op));
}

// 统一把 /admin/qw_ai_quality/options 不同字段名规整为 FilterCommon 期望的 { label, value } 结构
export function normalizeQwAiQualityOptions(raw) {
  return {
    tabs: raw.tabs || [],
    labels: raw.labels || [],
    statuses: raw.statuses || [],
    cities: (raw.cities || []).map(city => ({ label: city, value: city })),
    corps: (raw.corps || []).map(item => ({ label: item.corp_name, value: item.corpid })),
    contacts: (raw.contacts || []).map(item => ({ label: item.contact_name, value: item.contact_userid })),
    admins: (raw.admins || []).map(item => ({ label: item.real_name, value: item.id })),
    operations: raw.operations || [],
    canManageTimelinessRule: Boolean(raw.can_manage_timeliness_rule),
    canManageFeishuAlertPolicy: Boolean(raw.can_manage_feishu_alert_policy),
  };
}
